export const PRINTER_NAMES = {
  TSOLES: 'Pro',
  PODO: 'Sole',
  IDEAFORMER: 'Lite',
} as const;

export interface PrinterSetting {
    id: number,
    name: string,
}